<template>
  <div class="<md:min-h-screen">
    <div class="relative grid <md:h-full">
      <base-picture
        class="full grid-area-stack"
        fit="cover"
        :props-img="{ class: 'w-full', style: 'object-position: top right', role: 'presentation' }"
        :src="{
          sm: 'https://assets.thenorthface.eu/image/upload/v1723123860/240328-TNF-ss24-404-lp-m.jpg',
          md: 'https://assets.thenorthface.eu/image/upload/v1723123860/240328-TNF-ss24-404-lp-m.jpg',
          lg: 'https://assets.thenorthface.eu/image/upload/v1723186443/240328-TNF-SS24-404-LP-RIGHT.jpg',
        }"
      />
      <div class="grid-area-stack <lg:flex">
        <div class="px-4 py-16 md:max-w-2/3">
          <h1 class="display-2">
            {{ $t.maintenance.ERR403.title }}
          </h1>
          <p class="mt-4 lg:mt-6 lg:text-md">
            {{ $t.maintenance.ERR403.message }}
          </p>
          <vf-button class="mt-8 <md:w-full" @click="clearError({ redirect: '/' })">
            {{ $t.maintenance.ERR4xx.cta }}
          </vf-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
